import "./style.scss";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/src/store";
import { AOPMaltaCertificateData } from "@/src/types/admissionOffice";
import backForDocMalta from "@/src/assets/admissionOfficePage/back-for-doc-malta.webp";
import backForDocPoland from "@/src/assets/admissionOfficePage/back-for-doc-poland.webp";
import backForDocUkraine from "@/src/assets/admissionOfficePage/back-for-doc-ukraine.webp";
import backForDocEmpty from "@/src/assets/admissionOfficePage/back-for-doc-empty.png";
import backForDocCertificate from "@/src/assets/admissionOfficePage/back-for-doc-certificate.png";
import backForDocAuthorizationLetter from "@/src/assets/admissionOfficePage/back-for-doc-authorization-letter.png";

interface AOPPrevProps {
  bodyForPrev: AOPMaltaCertificateData;
  certificateInfo: string;
}

const AOPPrev: FC<AOPPrevProps> = ({ bodyForPrev, certificateInfo }) => {
  const [actualBg, setActualBg] = useState(backForDocMalta);
  const [actualCountryDoc, setActualCountryDoc] = useState("malta");
  const currentTab = useSelector((state: RootState) => state.admissionOfficeDoc.tabsAdmissionsOffice);

  useEffect(() => {
    switch (currentTab) {
      case "poland":
        setActualBg(backForDocPoland);
        setActualCountryDoc("poland");
        break;
      case "ukraine":
        setActualBg(backForDocUkraine);
        setActualCountryDoc("ukraine");
        break;
      default:
        setActualBg(backForDocMalta);
        setActualCountryDoc("malta");
        break;
    }
  }, [currentTab]);

  if (certificateInfo === "Certificate") {
    return (
      <div className="admission-office-prev-wrapper certificate">
        <div className={`admission-office-prev ${actualCountryDoc} certificate`}>
          <img className="admission-office-prev-background" src={backForDocCertificate} alt={`${backForDocCertificate}`} />
          <div className="admission-office-prev-section date-and-series">
            <div className="admission-office-prev-section-date">
              <span>{bodyForPrev.currentDate ? bodyForPrev.currentDate : ""}</span>
            </div>
            <div className="admission-office-prev-section-series">
              <span>N00 00-00/000</span>
            </div>
          </div>
          <div className="admission-office-prev-section full-name">
            <p>{bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
          </div>
          {bodyForPrev.body ? (
            <div className="admission-office-prev-section body-content">
              {bodyForPrev.body.map((item, idx) => (
                <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  if (certificateInfo === "Authorization Letter") {
    return (
      <div className="admission-office-prev-wrapper authorization-letter">
        <div className={`admission-office-prev ${actualCountryDoc} authorization-letter`}>
          <img className="admission-office-prev-background" src={backForDocAuthorizationLetter} alt={`${backForDocAuthorizationLetter}`} />
          <div className="admission-office-prev-section date-and-series">
            <span>N00 00-00/000</span> / <span>{bodyForPrev.currentDate ? bodyForPrev.currentDate : ""}</span>
          </div>
          <div className="admission-office-prev-section full-name">
            <p>{bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
          </div>
          {bodyForPrev.body ? (
            <div className="admission-office-prev-section body-content">
              {bodyForPrev.body.map((item, idx) => (
                <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="admission-office-prev-wrapper">
      <div className={`admission-office-prev ${actualCountryDoc}`}>
        <img className="admission-office-prev-background" src={backForDocEmpty} alt={`${backForDocEmpty}`} />
      </div>
    </div>
  );
};

export default AOPPrev;
